'use client'

import type { PayloadAdminBarProps, PayloadMeUser } from '@payloadcms/admin-bar'

import { cn } from '@/utilities/ui'
import { useSelectedLayoutSegments } from 'next/navigation'
import { PayloadAdminBar } from '@payloadcms/admin-bar'
import React, { useState } from 'react'
import { useRouter } from 'next/navigation'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { EnvironmentBadge } from '@/components/EnvironmentBadge'
import type { Locale } from '@/i18n'

import './index.scss'

import { getClientSideURL } from '@/utilities/getURL'

const baseClass = 'admin-bar'

const collectionLabels = {
  pages: {
    plural: 'Pages',
    singular: 'Page',
  },
  posts: {
    plural: 'Posts',
    singular: 'Post',
  },
  projects: {
    plural: 'Projects',
    singular: 'Project',
  },
}

const Title: React.FC = () => <span>Dashboard</span>

export const AdminBar: React.FC<{
  adminBarProps?: PayloadAdminBarProps
  locale?: Locale
  envConfig?: import('@/utilities/getEnvironment').EnvironmentConfig
}> = (props) => {
  const { adminBarProps, locale = 'uk', envConfig } = props || {}
  const segments = useSelectedLayoutSegments()
  const [_show, setShow] = useState(false)
  const collection = (
    collectionLabels[segments?.[1] as keyof typeof collectionLabels] ? segments[1] : 'pages'
  ) as keyof typeof collectionLabels
  const router = useRouter()

  const onAuthChange = React.useCallback((user: PayloadMeUser) => {
    setShow(Boolean(user?.id))
  }, [])

  return (
    <div className={cn(baseClass, 'py-2 bg-black text-white')}>
      <div className="container">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <EnvironmentBadge envConfig={envConfig} />
            <div className="flex-1">
              <PayloadAdminBar
                {...adminBarProps}
                className="py-2 text-white"
                classNames={{
                  controls: 'font-medium text-white',
                  logo: 'text-white',
                  user: 'text-white',
                }}
                cmsURL={getClientSideURL()}
                collectionSlug={collection}
                collectionLabels={{
                  plural: collectionLabels[collection]?.plural || 'Pages',
                  singular: collectionLabels[collection]?.singular || 'Page',
                }}
                logo={<Title />}
                onAuthChange={onAuthChange}
                onPreviewExit={() => {
                  fetch('/next/exit-preview').then(() => {
                    router.push('/')
                    router.refresh()
                  })
                }}
                style={{
                  backgroundColor: 'transparent',
                  padding: 0,
                  position: 'relative',
                  zIndex: 'unset',
                }}
              />
            </div>
          </div>
          <LanguageSwitcher currentLocale={locale} />
        </div>
      </div>
    </div>
  )
}
